import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { ReactComponent as ErrorIcon } from '@/assets/icons/bx-error.svg';
import { ReactComponent as CloseIcon } from '@/assets/icons/bx-x.svg';
import { Button } from '@/components/Elements';

export interface DeleteModalProps {
  type: 'image' | 'content' | 'project' | 'post'; // image: イメージ案, content: コンテンツ, project: 施策, post: 投稿制作
  open: boolean;
  handleDelete: () => void;
  handleCancel: () => void;
}

export const DeleteModal = (props: DeleteModalProps) => {
  const title = () => {
    switch (props.type) {
      case 'image':
        return 'イメージ案';
      case 'content':
        return 'コンテンツ';
      case 'project':
        return 'この施策';
      case 'post':
        return 'この投稿制作';
    }
  };
  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={props.handleCancel}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#6B7280BF] bg-opacity-[/75] transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="pointer-events-none">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="pointer-events-auto relative h-full w-[536px] overflow-hidden rounded-lg bg-white p-[24px]">
                  <div className="h-full w-[488px] bg-white">
                    <div className="mb-[10px] flex h-full w-[488px]">
                      <div className="mr-[16px] h-full">
                        <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-red-100">
                          <ErrorIcon width={24} height={24} fill="#DC2626"></ErrorIcon>
                        </div>
                      </div>
                      <div className="h-full w-[408px]">
                        <div className="mb-[8px] flex w-[408px] items-center justify-start">
                          <span className="text-lg font-medium leading-6 text-gray-900">
                            {title()}を削除してよろしいですか？
                          </span>
                        </div>
                        <div className="flex w-[408px] items-center justify-start">
                          <span className="text-sm font-normal leading-5 text-gray-500">
                            この作業は取り戻せません。
                          </span>
                        </div>
                      </div>
                      <div>
                        <CloseIcon width={24} height={24} fill="#9CA3AF" onClick={props.handleCancel} />
                      </div>
                    </div>
                    <div className="flex h-[38px] w-[488px] items-center justify-end">
                      <Button
                        variant="white"
                        size="md"
                        className="mr-[12px] h-[38px] w-[104px] whitespace-nowrap text-sm font-medium leading-5"
                        onClick={props.handleCancel}
                      >
                        キャンセル
                      </Button>
                      <Button
                        variant="red"
                        size="md"
                        className="h-[38px] w-[90px] whitespace-nowrap rounded-md text-sm font-medium leading-5"
                        onClick={props.handleDelete}
                      >
                        削除する
                      </Button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
